import React, { FC, useCallback } from 'react';
import styles from './_styles.module.scss';
import UIRouterLink from '../../../UI/UIRouterLink/UIRouterLink';
import UIButton from '../../../UI/UIButton/UIButton';
import {
  openInfoCreditsModal,
  openModal,
} from '../../../../redux/reducers/ui/ModalDialogSlice';
import { useAppDispatch } from '../../../../core/hooks/reduxHooks';
import { setSelectedAssignmentId } from '../../../../redux/reducers/ui/SubscriptionPackagesSlice';
import useWebContent from '../../../../core/hooks/useWebContent';
import { repostEmployerAssignment } from '../../../../redux/thunk/employerAssignments';

const ShortlistsAndBumps: FC<{
  assignmentId: string;
  shortlisted: number;
  shortlists_left: number;
  bumps: number;
  mobile?: boolean;
}> = ({ assignmentId, shortlisted, shortlists_left, bumps, mobile }) => {
  const dispatch = useAppDispatch();
  const [webContent] = useWebContent();

  const handleRepost = useCallback(() => {
    if (bumps > 0) {
      dispatch(repostEmployerAssignment(assignmentId));
    } else if (bumps === 0) {
      dispatch(setSelectedAssignmentId(assignmentId));
      dispatch(openInfoCreditsModal('bump'));
    }
  }, [assignmentId]);

  return (
    <div className={styles.payment_info}>
      <div className={styles.wrapper}>
        <p className={styles.value}>{shortlisted}</p>
        <p className={styles.title}>{webContent.shortlisted_web}</p>
      </div>
      <div className={styles.wrapper}>
        <p className={styles.value}>{shortlists_left}</p>
        <p className={styles.title}>{webContent.shortlists_left_web}</p>
        <UIButton
          title={webContent.buy_shortlists_web}
          callback={() => {
            dispatch(setSelectedAssignmentId(assignmentId));
            dispatch(openModal('purchase_shortlist'));
          }}
          classModificator={styles.btn}
        />
      </div>
      <div className={styles.wrapper}>
        <p className={styles.value}>{bumps}</p>
        <p className={styles.title}>{webContent.bumps_left_web}</p>
        {mobile && bumps > 0 ? (
          <UIButton
            title={'Bump'}
            callback={() => handleRepost()}
            classModificator={styles.btn_bump}
          />
        ) : (
          <UIButton
            title={webContent.buy_bumps_web}
            callback={() => {
              dispatch(setSelectedAssignmentId(assignmentId));
              dispatch(openModal('purchase_bump'));
            }}
            classModificator={styles.btn}
          />
        )}
      </div>
    </div>
  );
};

export default ShortlistsAndBumps;
